import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import BaseComponent from '../../../../components/BaseComponent';
import ListItemMission from './ListItemMission';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import * as actionsPicking from '../../../../actions/pickingAction';
import { ENUMS } from '../../../../utils/constants';
import PickingService from '../../../../services/PickingService';
import { isNullOrEmpty } from '../../../../utils/util';

class ListMission extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            id: undefined,
            message: '',
            eventRouteClick: '',
            mission: undefined,
            refreshed: false
        };
    }

    componentDidMount() {
        document.addEventListener('expeditionRefreshListOrderItems', this.refreshComponent);
    }

    componentWillUnmount() {
        document.removeEventListener('expeditionRefreshListOrderItems', this.refreshComponent);
    }

    refreshComponent = () => {
        this.setState({ refreshed: !this.state.refreshed });
    }

    onSelectItemChange = (event, selectedItem) => {
        const messageDefault = this.translate('expedition:picking.confirm-mission-start');
        // eslint-disable-next-line max-len
        this.setState({ message: messageDefault.replace('{location}', selectedItem.location), mission: selectedItem, eventRouteClick: event.currentTarget.pathname }, () => {
            this.messageModal.show();
        });
        event.preventDefault();
    }

    onConfirmModal = () => {
        if (this.state.mission.status === ENUMS.eOrderItemStatus.Waiting.value) {
            this.props.startOrderItem(this.state.mission.orderId, this.state.mission.orderItemId, () => {
                this.props.history.push({ pathname: this.state.eventRouteClick });
                this.props.setSelectedMission(this.state.mission);
            });
        } else {
            this.props.history.push({ pathname: this.state.eventRouteClick });
            this.props.setSelectedMission(this.state.mission);
        }
    }

    totalItems = () => {
        if (!this.props.order.items) {
            return '';
        }
        const total = this.props.order.items.filter((i) => i.status !== ENUMS.eOrderItemStatus.WaitingRepicking.value
            && i.status !== ENUMS.eOrderItemStatus.Repicking.value && i.status !== ENUMS.eOrderItemStatus.Canceled.value).length;

        const totalWaiting = this.props.order.items.filter((i) => i.status === ENUMS.eOrderItemStatus.Waiting.value).length;
        return `${(total - totalWaiting)}/${total}`;
    };

    checkRepicking = () => {
        if (!this.props.order.items) {
            return '';
        }
        const totalWaitingRepicking = this.props.order.items ? this.props.order.items.filter((i) => i.status === ENUMS.eOrderItemStatus.WaitingRepicking.value).length : 0;
        if (totalWaitingRepicking > 0) {
            return this.translate(`expedition:${ENUMS.eOrderItemStatus.WaitingRepicking.text}`);
        } else {
            const totalRepicking = this.props.order.items ? this.props.order.items.filter((i) => i.status === ENUMS.eOrderItemStatus.Waiting.value && !isNullOrEmpty(i.orderItemOriginCode)).length : 0;
            if (totalRepicking > 0) {
                return this.translate(`expedition:${ENUMS.eOrderItemStatus.Repicking.text}`);
            } else {
                return '';
            }
        }
    };

    render() {
        return (
            <div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <div className="col s12 subtitle">
                        <span style={{ marginLeft: '5px', display: 'inline-flex' }}>
                            Status: {this.totalItems()}
                        </span>
                        {
                            !isNullOrEmpty(this.checkRepicking()) ? (
                                <span className="truncate red-text" style={{ marginLeft: '10px', display: 'inline-flex' }}>
                                    <i className="material-icons">error_outline</i> {this.checkRepicking()}
                                </span>
                            ) : null
                        }
                    </div>
                    <ul className="col s12" style={{ padding: '0', marginTop: '0' }}>
                        {
                            this.props.order && this.props.order.items
                                // eslint-disable-next-line max-len
                                ? this.props.order.items.filter((i) => i.status === ENUMS.eOrderItemStatus.Waiting.value || i.status === ENUMS.eOrderItemStatus.InProgress.value).map((item) => {
                                    return (
                                        <ListItemMission
                                            key={item.orderItemId}
                                            {...this.props}
                                            route={`./missions/${item.orderItemId}`}
                                            data={item}
                                            onSelectChange={(event) => this.onSelectItemChange(event, item)}
                                        />
                                    );
                                }) : null
                        }
                    </ul>
                    <ConfirmModal
                        ref={((el) => this.messageModal = el)}
                        id="confirmOrderItemStart"
                        data={{ title: this.translate('validations:attention'), message: this.state.message }}
                        onConfirm={this.onConfirmModal}
                        btnCancel={this.translate('general:cancel')}
                        btnConfirm={this.translate('general:confirm')}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        order: state.pickingReducer.order
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedMission: (mission) => {
            dispatch(actionsPicking.selectMission(mission));
        },
        startOrderItem: (orderId, orderItemId, callback) => {
            dispatch(PickingService.startOrderItem(orderId, orderItemId, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListMission)));
